import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="bookings--price-calculator"
export default class extends Controller {
  static targets = ["total", "quantity", "spots"];
  static values = { price: Number, quantity: Number };

  updateQuantity() {
    this.quantityValue = this.spotsTarget.value;
  }

  quantityValueChanged() {
    this.quantityTarget.innerText = this.quantityValue;
    this.totalTarget.innerText = (
      (this.quantityValue * this.priceValue) /
      100.0
    ).toFixed(2);
  }
}
